import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { LoaderService } from '../../../../app/core/services/loading.service';
import dataConfig from '../../../../assets/policy-document-search-data.json';
import { AppConfig } from '../../../../config/app-config';
import { POLICY_DOCUMENT_SEARCH_DIRECTION } from '../../../../treo.properties';
import { ProgramService } from '../programs.service';

@Component({
    selector: 'app-policy-document-search',
    templateUrl: './policy-document-search.component.html',
    styleUrls: ['./policy-document-search.component.scss'],
    standalone: false
})
export class PolicyDocumentSearchComponent implements OnInit {
    direction: string = POLICY_DOCUMENT_SEARCH_DIRECTION;
    policyDocumentFormGroup: UntypedFormGroup;
    public JSON = JSON;
    policyLineOfBusinessConfig = AppConfig.policyLineOfBusinessConfig;
    policyStateDropdownConfig = AppConfig.policyStateDropdownConfig;
    policyPricingPlanDropdownConfig = AppConfig.policyPricingPlanDropdownConfig;
    policyPeriodDropdownConfig = AppConfig.policyPeriodDropdownConfig;
    policyNumberDropdownConfig = AppConfig.policyNumberDropdownConfig;
    buttonSearchConfig = AppConfig.buttonSearchConfig;
    lineOfBusinessData: string;
    pricingPlanData: string;
    stateData: string;
    policyPeriodData: string;
    policyNumberData: string;
    constructor(
        private fb: UntypedFormBuilder, public loaderService: LoaderService, public programsService: ProgramService, private router: Router
    ) {
        this.policyDocumentFormGroup = this.fb.group({
            policyLineOfBusiness: [[]],
            policyStateDropdown: [[]],
            policyPricingPlanDropdown: [[]],
            policyPeriodDropdown: [[]],
            policyNumberDropdown: [[]],

        });
    }

    ngOnInit(): void {
        this.fetchDropdownValues();
        this.buttonSearchConfig.name = 'policy-document-search-search-button';
        this.buttonSearchConfig.id = 'policy-document-search-search-button';
        this.lineOfBusinessData = JSON.stringify(dataConfig.lobDropdownConfig.dataSource);
        this.stateData = JSON.stringify(dataConfig.stateDropdownConfig.dataSource);
        this.pricingPlanData = JSON.stringify(dataConfig.pricingPlanDropdownConfig.dataSource);
        this.policyPeriodData = JSON.stringify(dataConfig.policyPeriodDropdownConfig.dataSource);
        this.policyNumberData = JSON.stringify(dataConfig.policyNumberDropdownConfig.dataSource);
    }

    policyLOB = [];
    pricingPlans = [];
    state = [];
    policyPeriod = [];
    policyNumber = [];
    customErrorMessage = 'You must select at least one Search option.'
    showErrorMsg = false

    policyPeriodOption = []
    policyLobOption = []
    policyStateOption = []
    fetchDropdownValues() {
        let payload = {
            "actionType": "PROGRAM_MANAGE",
            "operation": "PROGRAM_INIT_PARAMS",
            "organizationId": this.loaderService.getItem('orgId'),
        };
        this.loaderService.showLoader();
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.policyPeriodOption = resp.preparePricing
                this.policyLobOption = resp.lob
                this.policyStateOption = resp.state



                this.loaderService.hideLoader();
                if (resp.lob && resp.lob.length > 0) {
                    this.policyLOB = resp?.lob.map(item => {
                        return {
                            value: item.value,
                            label: item.name
                        };
                    });
                }
                if (resp.preparePricing && resp.preparePricing.length > 0) {
                    this.pricingPlans = resp?.preparePricing.map(item => {
                        return {
                            value: item.value,
                            label: item.name
                        };
                    });
                }
                // this.state = resp?.state.map(item => {
                //     return {
                //         value: item.value,
                //         label: item.sttDscrptn
                //     };
                // }).filter(item => item.value && item.label);

                if (resp.state && resp.state.length > 0) {
                    this.state = resp.state.map(item => {
                        const formattedLabel = item.sttDscrptn
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());

                        return {
                            value: item.value,
                            label: formattedLabel
                        };
                    });
                }

                if (resp.policyPeriod && resp.policyPeriod.length > 0) {
                    this.policyPeriod = resp?.policyPeriod.map(item => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                }
                if (resp.policyNumber && resp.policyNumber.length > 0) {
                    this.policyNumber = resp?.policyNumber.map(item => {
                        return {
                            value: item,
                            label: item.replace(/\*/g, '').trim()
                        };
                    });
                }
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    submit() {

        if (this.policyDocumentFormGroup.controls['policyPricingPlanDropdown'].value == '' && this.policyDocumentFormGroup.controls['policyLineOfBusiness'].value == '' && this.policyDocumentFormGroup.controls['policyStateDropdown'].value == '' && this.policyDocumentFormGroup.controls['policyPeriodDropdown'].value == '' && this.policyDocumentFormGroup.controls['policyNumberDropdown'].value == '') {
            this.showErrorMsg = true
        }
        else {
            this.showErrorMsg = false
            this.searchApiCall()
        }
    }

    payloadToSend: any

    searchApiCall() {

        let payload = {
            "actionType": "PROGRAM_MANAGE",
            "operation": "GetPolicySearch",
            "organizationId": this.loaderService.getItem('orgId'),
            "criteria": [
                {
                    "name": "Pricing Plan",
                    "items":
                        this.policyDocumentFormGroup.controls['policyPricingPlanDropdown'].value?.map((item: any) => ({
                            value: item.value
                        })) || []
                },
                {
                    "name": "Line of Business",
                    "items":
                        this.policyDocumentFormGroup.controls['policyLineOfBusiness'].value?.map((item: any) => ({
                            value: item.value
                        })) || []
                },
                {
                    "name": "Policy Number",
                    "items":
                        this.policyDocumentFormGroup.controls['policyNumberDropdown'].value?.map((item: any) => ({
                            value: item.value
                        })) || []

                },
                {
                    "name": "Policy Period",
                    "items":
                        this.policyDocumentFormGroup.controls['policyPeriodDropdown'].value?.map((item: any) => ({
                            value: item.value
                        })) || []
                },
                {
                    "name": "State",
                    "items":
                        this.policyDocumentFormGroup.controls['policyStateDropdown'].value?.map((item: any) => ({
                            value: item.value
                        })) || []
                },
            ]
        };
        this.payloadToSend = payload
        this.loaderService.showLoader();
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.router.navigate(['/program/policy-documents-search-results'],
                    {
                        state: {
                            payloadS: this.payloadToSend,
                            responseS: resp,
                            formValue: this.policyDocumentFormGroup.value
                        }
                    }
                )


            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });

    }


    onPolicyPeriodDeselect(event: any) {
        const currentSelection = this.policyDocumentFormGroup.controls['policyPeriodDropdown'].value || [];
        const updatedSelection = currentSelection.filter(item => item.value !== event.value);
        this.policyDocumentFormGroup.controls['policyPeriodDropdown'].setValue(updatedSelection);
        this.onPolicyPeriodChange();
    }
    onPolicyPeriodChange() {
        this.showErrorMsg = false
        const selected = this.policyDocumentFormGroup.controls['policyPeriodDropdown']?.value;
        const selectedLabels = selected?.map(item => item.label) || [];

        const dataToSend = {
            'Grouped By - Policy Period_3': [],
            'Grouped By - Policy Number_3': [],
        };
        dataToSend['Grouped By - Policy Period_3'] = selectedLabels;
    }
    onPolicyPeriodSelectDeselectAll(event: any) {
        this.policyDocumentFormGroup.controls['policyPeriodDropdown'].setValue(event);
        this.onPolicyPeriodChange();
    }

    // new state dropdown


    onStateSelectDeselectAll(event: any) {
        this.policyDocumentFormGroup.controls['policyStateDropdown'].setValue(event);
        this.onStateChange();
    }

    onStateDeselect(event: any) {
        const currentSelection = this.policyDocumentFormGroup.controls['policyStateDropdown'].value || [];
        const updatedSelection = currentSelection.filter(item => item.value !== event.value);
        this.policyDocumentFormGroup.controls['policyStateDropdown'].setValue(updatedSelection);
        this.onStateChange();
    }
    onStateChange() {
        this.showErrorMsg = false
        const selected = this.policyDocumentFormGroup.controls['policyStateDropdown']?.value;
        const selectedLabels = selected?.map(item => item.label) || [];

        const dataToSend = {
            'Grouped By - Policy Period_3': [],
            'Grouped By - Policy Number_3': [],
            'Grouped By - State_3': []
        };
        dataToSend['Grouped By - State_3'] = selectedLabels;
    }

    // new state dropdown


    // new lob dropdown

    onLobSelectDeselectAll(event: any) {
        this.policyDocumentFormGroup.controls['policyLineOfBusiness'].setValue(event);
        this.onLobChange();
    }

    onLobDeselect(event: any) {
        const currentSelection = this.policyDocumentFormGroup.controls['policyLineOfBusiness'].value || [];
        const updatedSelection = currentSelection.filter(item => item.value !== event.value);
        this.policyDocumentFormGroup.controls['policyLineOfBusiness'].setValue(updatedSelection);
        this.onLobChange();
    }
    onLobChange() {
        this.showErrorMsg = false
        const selected = this.policyDocumentFormGroup.controls['policyLineOfBusiness']?.value;
        const selectedLabels = selected?.map(item => item.label) || [];

        const dataToSend = {
            'Grouped By - Policy Period_3': [],
            'Grouped By - Policy Number_3': [],
            'Grouped By - State_3': [],
            'Grouped By - Lob_3': []
        };
        dataToSend['Grouped By - Lob_3'] = selectedLabels;
    }

    // new lob dropdown

    // new policy pricing dropdown

    onPricingPolicySelectDeselectAll(event: any) {
        this.policyDocumentFormGroup.controls['policyPricingPlanDropdown'].setValue(event);
        this.onLobChange();
    }

    onPricingPolicyDeselect(event: any) {
        const currentSelection = this.policyDocumentFormGroup.controls['policyPricingPlanDropdown'].value || [];
        const updatedSelection = currentSelection.filter(item => item.value !== event.value);
        this.policyDocumentFormGroup.controls['policyPricingPlanDropdown'].setValue(updatedSelection);
        this.onLobChange();
    }
    onPricingPolicyChange() {
        this.showErrorMsg = false
        const selected = this.policyDocumentFormGroup.controls['policyPricingPlanDropdown']?.value;
        const selectedLabels = selected?.map(item => item.label) || [];

        const dataToSend = {
            'Grouped By - Policy Period_3': [],
            'Grouped By - Policy Number_3': [],
            'Grouped By - State_3': [],
            'Grouped By - Lob_3': [],
            'Grouped By - Policy Price_3': []
        };
        dataToSend['Grouped By - Policy Price_3'] = selectedLabels;
    }


    // new policy pricing dropdown


    onPolicyNumberDeselect(event: any) {
        const currentSelection = this.policyDocumentFormGroup.controls['policyNumberDropdown'].value;
        const updatedSelection = currentSelection.filter(item => item !== event);
        this.policyDocumentFormGroup.controls['policyNumberDropdown'].setValue(updatedSelection);
        this.onPolicyNumberChange();
    }
    onPolicyNumberChange() {
        this.showErrorMsg = false
        const selected = this.policyDocumentFormGroup.controls['policyNumberDropdown']?.value;
        const selectedLabels = selected?.map(item => item.label) || [];

        const dataToSend = {
            'Grouped By - Policy Period_3': [],
            'Grouped By - Policy Number_3': [],
        };
        dataToSend['Grouped By - Policy Number_3'] = selectedLabels;

    }
    onPolicyNumberSelectDeselectAll(event: any) {
        this.policyDocumentFormGroup.controls['policyNumberDropdown'].setValue(event);
        this.onPolicyNumberChange();
    }

    policyPricingPlanValue = []
    policyLobValue = []
    policyStateValue = []

    detectSelectedOptions(event: any, controlName: string, placeholder: string) {
        if (event.target.value !== '') {
            this.showErrorMsg = false
            if (placeholder === 'Policy Pricing Plan') {
                this.policyPricingPlanValue = event.detail.value
            }
            if (placeholder === 'Line Of Business') {
                this.policyLobValue = event.detail.value
            }
            if (placeholder === 'State') {
                this.policyStateValue = event.detail.value
            }
        }
    }

}
